<template>
  <v-dialog
    v-model="dialog"
    :fullscreen="isMobile"
    :hide-overlay="isMobile"
    width="50%"
  >
    <v-card style="background-color: #e3e3e3">
      <v-col class="d-flex pt-2 pb-0">
        <v-btn
          icon
          :autofocus="false"
          @click="dialog = false"
        >
          <v-icon
            large
            class="close-hover"
            color="grey"
          >
            mdi-close
          </v-icon>
        </v-btn>
      </v-col>
      <v-card-text
        v-if="product"
        class="pa-0 px-4"
      >
        <div class="d-flex px-2">
          {{ $t('edit') }} : <h3>{{ product.name }}</h3>(<h5>{{ $t('code') }} : {{ product.code }}</h5>)
        </div>
        <v-row class="mt-4 mx-0">
          <v-col
            v-show="product.type == 'product'"
            cols="12"
            md="4"
            class="mb-0"
          >
            <v-text-field
              v-model="product.barcode"
              :label="$t('barcode')"
              height="20"
              dense
              outlined
              class="mb-1 dense"
              clearable
            >
              <template v-slot:prepend-inner>
                <v-btn
                  color="primary"
                  icon
                  x-small
                  @click="openNumpad('barcode')"
                >
                  <v-icon style="font-size: 26px;margin-top: 2px">
                    mdi-calculator
                  </v-icon>
                </v-btn>
              </template>
            </v-text-field>
          </v-col>
          <v-col
            cols="12"
            md="4"
            class="mb-1"
          >
            <money
              ref="refMoney"
              v-model="product.price"
              :label="$t('fixSellPrice')"
              :dense="true"
              :outlined="true"
              :solo="false"
              :clearable="true"
              :numpad="true"
              :autofocus="true"
              value-when-is-empty=""
              :options="options"
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
            class="mb-0  "
          >
            <v-text-field
              v-model="product.tax_percent"
              :label="$t('taxPercent')"
              height="20"
              dense
              type="number"
              outlined
              class="mb-1 dense"
              clearable
            >
              <template v-slot:prepend-inner>
                <v-btn
                  color="primary"
                  icon
                  x-small
                  @click="openNumpad('taxPercent')"
                >
                  <v-icon style="font-size: 26px;margin-top: 2px">
                    mdi-calculator
                  </v-icon>
                </v-btn>
              </template>
            </v-text-field>
          </v-col>
          <v-col
            cols="12"
            md="4"
            class="mb-0  "
          >
            <v-text-field
              v-model="product.discount_percent"
              :label="$t('discountPercent')"
              height="20"
              dense
              type="number"
              outlined
              class="mb-1 dense"
              clearable
            >
              <template v-slot:prepend-inner>
                <v-btn
                  color="primary"
                  icon
                  x-small
                  @click="openNumpad('discountPercent')"
                >
                  <v-icon style="font-size: 26px;margin-top: 2px">
                    mdi-calculator
                  </v-icon>
                </v-btn>
              </template>
            </v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="pt-7 py-3 mx-3">
        <v-btn
          v-shortkey="['shift','f1']"
          @shortkey="updateArticle"
          class=" mx-0"
          color="teal"
          @click="updateArticle"
        >
          {{ $t('updateArticle') }} (shift+f1)
        </v-btn>
        <v-spacer />
        <v-btn
          v-shortkey="['shift','f2']"
          @shortkey="update"
          class=" mx-0"
          color="primary"
          :loading="loading"
          @click="update"
        >
          {{ $t('updateProductAndChangeArticle') }} (shift+f2)
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-dialog
      v-model="numpadDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="325"
    >
      <v-card style="background-color: #e3e3e3">
        <v-col class="d-flex pt-2 pb-0">
          <v-btn
            icon
            @click="numpadDialog = false"
          >
            <v-icon
              class="close-hover"
              large
              color="grey"
            >
              mdi-close
            </v-icon>
          </v-btn>
          <h3 class="mx-auto font-weight-medium mt-2">
            {{ $t(numpadLable) }}
          </h3>
        </v-col>
        <v-card-text class="pa-0">
          <div
            class="overflow-y-auto ma-1 mx-0 mt-0"
          >
            <numpad
              :input="numpadValue"
              :label="numpadLable"
              @save="setNumpad"
            />
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="snakbar"
      :color="(snakbarColor ? snakbarColor : 'primary')"
      top
      style="z-index: 1000000000000 !important;"
    >
      {{ snakbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="snakbar = !snakbar"
        >
          {{ $t('close') }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-dialog>
</template>

<script>
  import General from '@/Mixins/general'

  export default {
    name: 'ProductDialog',
    components: {
      numpad: () => import('../../../components/general/numpad/index(old).vue'),
    },
    mixins: [General],
    model: { prop: 'value', event: 'input' },
    props: ['value', 'item'],
    data () {
      return {
        loading: false,
        numpadDialog: false,
        numpadLable: null,
        numpadValue: null,
        product: null,
      }
    },
    computed: {
      dialog: {
        get: function () {
          return this.value
        },
        set: function (newValue) {
          this.$emit('input', newValue)
        },
      },
    },
    watch: {
      item (val) {
        this.product = val.product
      },
      dialog (val) {
        if (val) {
          // this.$refs.refMoney.setFocus()
        }
        this.$emit('input', val)
      },
      value (val) {
        if (!val) {
          this.$store.commit('SET_PREINPUT', null)
        }
      },
    },
    mounted () {
      window.addEventListener('focusin', this.focusOff)
      if (this.item) {
        this.product = this.item.product
      }
    },
    methods: {
      focusOff () {
        if (!this.$store.state.autoFocus) {
          var preInput = this.$store.state.preInput
          var element = window.document.activeElement
          if (element.tagName.toLowerCase() === 'input') {
            if (element.autofocus && !preInput) {
              this.$store.commit('SET_PREINPUT', element)
            }
          } else {
            if (preInput && !element.classList.contains('notranslate')) {
              setTimeout(function () {
                preInput.focus()
              }, 100)
            } else {
              this.$store.commit('SET_PREINPUT', null)
            }
          }
        }
      },
      openNumpad (type) {
        if (type === 'barcode') {
          this.numpadValue = this.product.barcode
        }
        if (type === 'taxPercent') {
          this.numpadValue = this.product.tax_percent
        }
        if (type === 'discountPercent') {
          this.numpadValue = this.product.discount_percent
        }
        this.numpadLable = this.$t(type)
        this.selectedInput = type
        this.numpadDialog = true
      },
      setNumpad (data) {
        this.numpadDialog = false
        if (this.selectedInput === 'barcode') {
          this.product.barcode = data
        }
        if (this.selectedInput === 'taxPercent') {
          this.product.tax_percent = data
        }
        if (this.selectedInput === 'discountPercent') {
          this.product.discount_percent = data
        }
      },
      update () {
        var app = this
        app.loading = true
        app.$axios.get(this.$endpoint + 'products', {
          params: {
            updateProduct: 'active',
            product: app.product,
          },
        })
          .then(res => {
            res = res.data
            app.updateOffline()
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      updateOffline () {
        if (parseFloat(this.product.price) === 0 || !this.product.price || this.product.price === '') {
          this.snakbarText = this.$t('pleasEnterPrice')
          this.snakbarColor = 'pink'
          this.snakbar = true
          return false
        }
        var isDB = localStorage.getItem('dbCreated')
        if (isDB) {
          this.DBCreate()
        }
        if (isDB && isDB === 'active') {
          this.loading = true
          this.loadingDialog = true
          var app = this
          var connection = new window.JsStore.Connection()
          connection.openDb('db_' + this.$store.state.userId)
          connection.update({
            in: 'products',
            set: {
              barcode: app.product.barcode,
              price: app.product.price,
              tax_percent: app.product.tax_percent,
              discount_percent: app.product.discount_percent,
            },
            where: {
              id: app.product.id,
            },
          }).then(function (results) {
          })
          connection.update({
            in: 'productShortcutItems',
            set: {
              barcode: app.product.barcode,
              price: app.product.price,
              tax_percent: app.product.tax_percent,
              discount_percent: app.product.discount_percent,
            },
            where: {
              id: app.product.id,
            },
          }).then(function (results) {
            app.$emit('setItem', app.product)
            app.dialog = false
          })
        }
      },
      updateArticle () {
        if (parseFloat(this.product.price) === 0 || !this.product.price || this.product.price === '') {
          this.snakbarText = this.$t('pleasEnterPrice')
          this.snakbarColor = 'pink'
          this.snakbar = true
          return false
        }
        this.$emit('setItem', this.product)
        this.dialog = false
      },
    },
  }
</script>

<style scoped>

</style>